<template>
  <div class="main-content login">
    <section class="login-container">
      <div class="container">
        <div class="row">
          <div class="col-md-6 col-md-push-3">
            <div class="border-1px p-25">
              <div v-if="action == 'process'">Loading...</div>
              <div v-if="action == 'failed'">
                <p>
                  Silahkan login menggunakan email dan password yang telah didaftarkan
                  <b-link :to="{ path: '/sign-up' }">disini</b-link>. Jika belum memiliki akun silahkan mendaftarkan akun
                  <b-link :to="{ path: '/sign-up' }">disini</b-link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { TERRA_APPOINTMENT } from "../config/VariableComponents";
import router from "../router";
export default {
  data() {
    return {
      appointment_url: TERRA_APPOINTMENT,
      action: "",
    };
  },
  created() {
    this.action = this.$route.params.action;
  },
  mounted() {
    this.checkUser();
  },
  methods: {
    checkUser() {
      let getUserData = localStorage.getItem("user_data");
      if (getUserData != undefined) {
        this.logged = true;
        this.user_data = JSON.parse(getUserData);

        let url = this.appointment_url + "?norm=" + this.user_data.rm;
        if (this.action == "process") window.location = url;
      } else router.push({ name: "login" });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/pages/AppointmentMiddleware.vue